import { render, staticRenderFns } from "./reversedDetails.vue?vue&type=template&id=9b11245e&"
import script from "./reversedDetails.vue?vue&type=script&lang=js&"
export * from "./reversedDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports